import styled from "styled-components";

import { FLIGHT_TYPE_CF } from "../../../constants";

export const Wrapper = styled("div")(({ theme, $isCompact }) => ({
  ...theme.paddings(0, 15),
  ...($isCompact
    ? {
        ...theme.paddings(20, 0, 45),
      }
    : {
        position: "absolute",
        bottom: 120,
        left: 0,
        zIndex: 20,
      }),
  width: "100%",

  [theme.down("sm")]: {
    ...theme.paddings($isCompact ? 20 : 0, 15, $isCompact ? 45 : 0),
    position: "relative",
    bottom: 0,
  },
}));

export const FormBlock = styled("div")(({ theme, flightType }) => ({
  ...(flightType !== FLIGHT_TYPE_CF ? {} : { flexWrap: "wrap" }),
  display: "flex",
  gap: flightType !== FLIGHT_TYPE_CF ? 13 : 13,

  [theme.down("md")]: {
    flexWrap: "wrap",
    justifyContent: "space-between",
    rowGap: 10,
  },

  [theme.down("sm")]: {
    ...(flightType !== FLIGHT_TYPE_CF ? {} : { rowGap: 20 }),
  },
}));

export const SwapAirportButton = styled("button")(({ theme }) => ({
  ...theme.mixins.flexCenterCenter,
  width: 36,
  height: 36,
  border: `1px solid ${theme.palette.fly.brandBorder}`,
  position: "absolute",
  left: "calc(50% - 18px)",
  top: "calc(50% - 18px)",
  zIndex: 10,
  borderRadius: "50%",
  fontSize: 18,
  color: theme.palette.fly.inputBg,
  backgroundColor: theme.palette.fly.brand,
  lineHeight: 1,
  cursor: "pointer",
  transform: "rotate(90deg)",
  boxShadow: "0 2px 6px rgba(0,0,0,.15)",
  transition: "all .3s ease",

  "&:hover": {
    backgroundColor: theme.palette.fly.brandHover,
    boxShadow: "0 3px 8px rgba(0,0,0,.2)",
    transform: "rotate(270deg)",
  },

  "&:active": {
    transform: "rotate(270deg) scale(0.95)",
  },

  [theme.down("sm")]: {
    transform: "none",

    "&:hover": {
      transform: "rotate(180deg)",
    },
  },
}));

export const RouteBlock = styled("div")(({ theme, gap, smGap }) => ({
  display: "flex",
  gap: gap || 13,
  position: "relative",
  width: "100%",

  [theme.down("sm")]: {
    flexDirection: "column",
    width: "100%",
    gap: smGap || 10,
  },
}));

export const RemoveRouteButton = styled("button")(({ theme }) => ({
  ...theme.mixins.flexCenterCenter,
  width: 22,
  height: 22,
  position: "absolute",
  right: -7,
  top: -7,
  zIndex: 10,
  borderRadius: "50%",
  border: "none",
  fontSize: 16,
  color: theme.palette.white,
  backgroundColor: theme.palette.removeRouteButtonBg,
  lineHeight: 1,
  cursor: "pointer",
}));

export const SearchFormBlock = styled("div")(({ theme }) => ({
  ...theme.paddings(20, 30, 40),
  position: "relative",
  borderRadius: 24,
  backgroundColor: theme.palette.white,
  boxShadow: theme.palette.fly.formShadow,
  maxWidth: 1300,
  ...theme.margins(0, "auto"),

  [theme.down("sm")]: {
    ...theme.paddings(15, 15, 35),
    borderRadius: 16,
  },
}));

export const SelectAirportsFromToBlock = styled("div")(({ theme }) => ({
  display: "flex",
  gap: 13,
  position: "relative",
  flex: "1 1 44%",
  minWidth: 0,

  [theme.down("md")]: {
    flex: "0 0 auto",
  },

  [theme.down("sm")]: {
    flexDirection: "column",
    gap: 10,
    width: "100%",
  },
}));

export const AddRouteButton = styled("button")(({ theme, disabled }) => ({
  ...(disabled ? { cursor: "not-allowed", opacity: 0.5 } : { cursor: "pointer" }),
  backgroundColor: theme.palette.fly.inputBg,
  border: `1px dashed ${theme.palette.fly.brandBorder}`,
  flex: "1 1 auto",
  minWidth: 0,
  height: 60,
  color: theme.palette.fly.brand,
  fontSize: 16,
  fontWeight: 600,
  letterSpacing: "0.06em",
  borderRadius: 7,
  transition: "all .2s ease",

  ...(disabled
    ? {}
    : {
        "&:hover": {
          borderColor: theme.palette.fly.brand,
          backgroundColor: theme.palette.white,
        },
      }),

  [theme.down("sm")]: {
    flex: "0 0 auto",
    width: "100%",
  },
}));

export const SearchButtonBlock = styled("div")(({ theme }) => ({
  ...theme.mixins.flexCenterCenter,
  position: "absolute",
  left: "50%",
  transform: "translateX(-50%)",
  bottom: -25,
  zIndex: 5,
}));

export const SearchButton = styled("button")(({ theme }) => ({
  ...theme.paddings(10, 32),
  border: "none",
  backgroundColor: theme.palette.fly.brand,
  cursor: "pointer",
  height: 50,
  fontSize: 16,
  fontWeight: 600,
  color: theme.palette.white,
  borderRadius: 12,
  transition: "all .2s ease",
  boxShadow: "0 4px 12px rgba(37, 99, 235, 0.3)",
  whiteSpace: "nowrap",

  "&:hover": {
    backgroundColor: theme.palette.fly.brandHover,
    boxShadow: "0 6px 16px rgba(37, 99, 235, 0.4)",
    transform: "translateX(0) translateY(-1px)",
  },

  "&:active": {
    transform: "translateX(0) translateY(0)",
    boxShadow: "0 4px 12px rgba(37, 99, 235, 0.3)",
  },
}));
